import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

export interface ESRProfitabilityCalculationResponse {
  "pv_hint": string,
  "pv": {
        "area": number,
        "hint": string,
        "elec_annual_savings": number,
        "elec_self_consumption": number
    },
  "savings_percentage": number,
  "monthly_possible_savings": number,
  "period_under_review_savings": number,
  "period_unter_review": number,
  "annual_energy_consumption_kwh_current": number,
  "annual_energy_consumption_kwh_planned": number,
  "energy_efficiency_class_current": number,
  "energy_efficiency_class_planned": number,
  "co2_emission_current": number,
  "co2_emission_planned": number,
  "annual_savings_on_energy_costs": number,
  "total_investment_costs": number,
  "total_beg_subsidy": number,
  "co2_tax_savings": number,
  "savings_over_lifetime": number,
  "energy_savings_percentage": number,
}


export const ESRProfitabilityCalculationResponseSchema : SchemaObject = {
  pv_hint: 'string',
  pv: {
      area: 'number',
      hint: 'string',
      elec_annual_savings: 'number',
      elec_self_consumption: 'number'
  },
  savings_percentage: 'number',
  monthly_possible_savings: 'number',
  period_under_review_savings: 'number',
  period_under_review: 'number',
  annual_energy_consumption_kwh_current: 'number',
  annual_energy_consumption_kwh_planned: 'number',
  energy_efficiency_class_current: 'number',
  energy_efficiency_class_planned: 'number',
  co2_emission_current: 'number',
  co2_emission_planned: 'number',
  annual_savings_on_energy_costs: 'number',
  total_investment_costs: 'number',
  total_beg_subsidy: 'number',
  co2_tax_savings: 'number',
  savings_over_lifetime: 'number',
  energy_savings_percentage: 'number'
}

  

export class ESRProfitabilityCalculation extends Request<ESRProfitabilityCalculationResponse>{
    override method : TRequestMethod = "GET";
    override responseSchema : Schema = ESRProfitabilityCalculationResponseSchema;

    constructor (
        public sessionToken: string,
        public energyIncreaseRate: number = 0,
        public co2Price: number = 0
      ){
        super();
    }

    override route() : string{
        return `${BASEURL}/profitability_calculation?sessionToken=${this.sessionToken}&energyIncreaseRate=${this.energyIncreaseRate}&co2Price=${this.co2Price}`;
    }
}